import classnames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import mapPointerIcon from '../../icons/mapPointerIcon.svg';
import chartsIcon from '../../icons/chartsIcon.svg';
import documentChatIcon from '../../icons/documentChatIcon.svg';
import styles from './stepOne.module.scss';
import SignUpNomadFeatures, {
  ISignUpNomadFeatures,
} from './SignUpNomadFeatures';

export const signUpNomadFeatures: ISignUpNomadFeatures[] = [
  {
    id: 1,
    icon: mapPointerIcon,
    iconAlt: 'Map pointer icon',
    title: 'Connect or Data Relationship Manager (DRM)',
    description:
      'After submitting your details you can start building your DRM and searching for data.',
  },
  {
    id: 2,
    icon: chartsIcon,
    iconAlt: 'Charts icon',
    title: 'Data Providers',
    description:
      'Once your account is reviewed you will receive an email and can start connecting' +
      ' with buyers.',
  },
  {
    id: 3,
    icon: documentChatIcon,
    iconAlt: 'Document chat icon',
    title: 'Document Chat',
    description:
      'Save time scouring pages of text for the critical information you need. Once your' +
      " account is created a member of Nomad's team will reach out to help you get started.",
  },
];

const StepOne = ({ goNextStep }: { goNextStep: () => void }) => {
  return (
    <>
      <h1 className={classnames(styles.title)}>Welcome to Nomad Data!</h1>
      <div className={classnames(styles.container)}>
        <SignUpNomadFeatures signUpNomadFeatures={signUpNomadFeatures[0]} />
        <SignUpNomadFeatures signUpNomadFeatures={signUpNomadFeatures[1]} />
        <SignUpNomadFeatures signUpNomadFeatures={signUpNomadFeatures[2]} />
      </div>
      <Button
        className={classnames('px-4 mx-auto', styles.button)}
        size="lg"
        onClick={goNextStep}
        data-cy="signup:next-button"
      >
        Next
      </Button>
    </>
  );
};

export default StepOne;
